import React from 'react';
import { Link, useHistory } from 'react-router-dom';

// redux
import { useSelector } from 'store'

// function
import MoveWithMarketo from 'function/MoveWithMarketo';

// scss
import './Menu.scss';

type Props = {}

const Menu: React.FC<Props> = (props) => {

  // selector
  const { isMenuOpen } = useSelector((state) => {
    return {
      isMenuOpen: state.isMenuOpen,  // ここでコード補完がきちんと効く
    };
  });

  // history
  const history = useHistory();

  return (
    <div id="Menu" className={ isMenuOpen ? 'isMenuOpen' : '' }>
      <div className="bg">
        <ul className="link01">
          {/* <li className="snsShare hidePc">
            <p className="text">SHARE</p>
            <p className="twitterLink"><a href="https://twitter.com/share?text=%E3%82%B3%E3%82%AF%E3%83%A8%E5%93%81%E5%B7%9D%E3%82%B7%E3%83%A7%E3%83%BC%E3%83%AB%E3%83%BC%E3%83%A0%0D%0A&url=https://fair2021.kokuyo-furniture.co.jp/digital/fair2021/showroom/index.html">Twitter</a></p>
            <p className="facebookLink"><a href="http://www.facebook.com/share.php?u=https://fair2021.kokuyo-furniture.co.jp/digital/fair2021/showroom/index.html" rel="noreferrer" target="_blank">Facebook</a></p>
          </li> */}
          <li><Link to="/digital/fair2021/showroom/index.html?nointro=1">SHOWROOM TOP</Link></li>
          <li><Link to="/digital/fair2021/showroom/floormap.html">フロアマップから見る</Link></li>
          <li><Link to="/digital/fair2021/showroom/activity.html">７つのアクティビティで見る</Link></li>
          <li><Link to="/digital/fair2021/showroom/new.html">展示商品を確認する</Link></li>
          <li><a href="https://www.kokuyo-furniture.co.jp/showroom/tokyo-sr/">ABOUT SHOWROOM</a></li>
          <li><Link to="/digital/fair2021/showroom/access.html">ACCESS</Link></li>
        </ul>
      </div>
    </div>
  );
}

export default Menu;
